import { render, staticRenderFns } from "./ShowMaterialbankFiles.vue?vue&type=template&id=a1bd8068&"
import script from "./ShowMaterialbankFiles.vue?vue&type=script&lang=js&"
export * from "./ShowMaterialbankFiles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports